import React, { useEffect, useState } from 'react';
import { subscribeFeedback } from '../utils/feedback';

const MAX_TOASTS = 4;

const FeedbackToasts = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribeFeedback((toast) => {
      setToasts((previous) => {
        const next = [...previous, toast];
        return next.slice(-MAX_TOASTS);
      });

      const lifetime = typeof toast.duration === 'number' ? toast.duration : 2600;
      window.setTimeout(() => {
        setToasts((previous) => previous.filter((item) => item.id !== toast.id));
      }, lifetime);
    });

    return unsubscribe;
  }, []);

  return (
    <div className="feedback-toasts" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div key={toast.id} className={`feedback-toast neumorphic-card feedback-${toast.kind}`} role="status">
          {toast.content}
        </div>
      ))}
    </div>
  );
};

export default FeedbackToasts;
